export default "__VITE_ASSET__B70I3NJw__"